import { useDashboardsList } from '../hooks';
import { ReportsTypes } from '../types';

export const useDashboardsTagsList = (type: ReportsTypes = ReportsTypes.Visual) => {
  const { data: dashboards = [], ...rest } = useDashboardsList(type);
  const data = [...new Set(dashboards.flatMap(dashboard => dashboard.tags || []))].filter(Boolean);

  return {
    ...rest,
    data,
  };
};
